import { Reveal } from "@/components/Reveal";

const stats = [
  { value: "8", label: "Years in business", sub: "Since 2018" },
  { value: "Boston", label: "Based & locally owned", sub: "Greater Boston & MetroWest" },
  { value: "1", label: "Focus: radon only", sub: "Not an HVAC sideline" },
];

export default function About() {
  return (
    <section id="about" className="bg-white py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 items-center gap-14 lg:grid-cols-12">
          <Reveal className="lg:col-span-5">
            <div className="relative">
              <div
                aria-hidden="true"
                className="absolute -inset-3 rounded-2xl border border-slate-300"
              />
              <img
                src="https://images.unsplash.com/photo-1582080811572-83424d756bef?crop=entropy&cs=srgb&fm=jpg&q=85"
                alt="Historic brick rowhomes in a Boston neighborhood"
                className="relative h-[380px] w-full rounded-xl object-cover shadow-xl lg:h-[460px]"
              />
              <div className="absolute -bottom-6 -right-4 rounded-xl bg-navy px-6 py-4 shadow-xl sm:-right-8">
                <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-gold-light">
                  Est.
                </p>
                <p className="font-display text-3xl font-bold text-white">2018</p>
              </div>
            </div>
          </Reveal>

          <div className="lg:col-span-7">
            <Reveal>
              <p className="font-mono text-xs uppercase tracking-[0.22em] text-gold-deep">
                About us
              </p>
              <h2 className="mt-3 font-display text-2xl font-semibold tracking-tight text-navy sm:text-3xl lg:text-4xl">
                Eight years. One focus: the air in your home.
              </h2>
              <div className="mt-6 space-y-4 text-slate-600">
                <p>
                  Home Defense Solutions LLC was founded in the Boston area in
                  2018 with a simple observation: Eastern Massachusetts — with
                  its granite bedrock, older foundations and proud century-old
                  basements — is genuine radon country, and most homeowners have
                  no idea what their level is.
                </p>
                <p>
                  So we built a company that does one thing, properly. No HVAC
                  sideline, no upsells, no fear tactics. We test your home with
                  calibrated continuous monitors, explain the results in plain
                  English, and if your level is high, we engineer a mitigation
                  system around your actual foundation — not a template.
                </p>
                <p>
                  Eight years on, we are still locally owned, still licensed and
                  insured, and still answering our own phone.
                </p>
              </div>
            </Reveal>

            <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-3">
              {stats.map((s, i) => (
                <Reveal key={s.label} delay={0.08 * i}>
                  <div
                    data-testid={`about-stat-${i + 1}`}
                    className="h-full rounded-xl border border-slate-200 bg-limestone p-5"
                  >
                    <p className="font-display text-3xl font-bold text-navy">{s.value}</p>
                    <p className="mt-1 text-sm font-semibold text-slate-700">{s.label}</p>
                    <p className="mt-0.5 text-xs text-slate-500">{s.sub}</p>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
